export function getHumanReadableRoute (
  $bookings
){
  'ngInject';

  this.routes = $bookings.collections.routes;

  return ( input ) => {
    let result = '';
    this.routes.map(route => {
      if( route.uri == input ){
        result = `${route.loading_port} → ${route.unloading_port}`;
      }
    } );
    return result;
  }

}


/** WEBPACK FOOTER **
 ** ./frontend/components/booking/getHumanReadableRoute.filter.js
 **/